module.exports = __webpack_public_path__ + "static/img/banner.2cee7697.png";